// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__DZZ4K","summary":"CartItem_summary__bL33x","price":"CartItem_price__NvXiZ","amount":"CartItem_amount__P4tFD","actions":"CartItem_actions__gtUdF"};